export default __webpack_public_path__ + "static/media/R7SR45.6c12b54a.png";